<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="col-xl-12">
            <div class="card card-header-actions mx-auto">
                <div class="card-header">Employee Leave Balance
                    <div class="float-right">
                        <button data-toggle="modal" class="btn btn-primary btn-sm" (click)="templateDownload()"> Template
                        </button>&nbsp;&nbsp;

                        <input type="file" class="d-none" id="testResults" #testResults
                            (change)="onFileSelected($event)" (click)="testResults.value = null" accept=".xlsx, .xls">
                        <button class="btn btn-sm btn-success" (click)="testResults.click()"><i
                                class="fa fa-upload" aria-hidden="true"></i>&nbsp;Upload</button>
                        &nbsp;&nbsp;
                    </div>
                </div>
                <div class="card-body">
                    <div class="col-xl-12">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-sm" datatable [dtOptions]="dtOptions"
                                *ngIf="dtRender">
                                <thead>
                                    <tr>
                                        <th>Sl.No</th>
                                        <th>Employee Id</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Location</th>
                                        <th>Leave Taken</th>
                                        <th>Old Balance</th>
                                        <th>Opening Balance</th>
                                        <th>Remaining Balance</th>
                                        <th>Month</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of lstGrid;let i =index">
                                        <td>{{i+1}}</td>
                                        <td>{{item?.user_id}}</td>
                                        <td>{{item?.name}}</td>
                                        <td>{{item?.designation}}</td>
                                        <td>{{item?.mvu}}</td>
                                        <td>{{item?.leave_taken}}</td>
                                        <td>{{item?.old_balance}}</td>
                                        <td>{{item?.opening_balance}}</td>
                                        <td>{{item?.remaining_balance}}</td>
                                        <td style="white-space: nowrap;">{{item?.month_name?.slice(0, 3)}}{{item?.created_on | date :'-yyyy'}}</td>
                                        <td>
                                            <div class="d-flex align-items-center gap-2">
                                                <input type="text" class="form-control form-control-sm"[(ngModel)]="item.openingBalance"
                                                    [ngModelOptions]="{standalone :true}"
                                                    style="width: 80px;">&nbsp;&nbsp;&nbsp;
                                                <button class="btn btn-sm btn-primary" 
                                                    (click)="updateLeave(item)">Save</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>